import React from "react";
import type {VoidFunctionComponent} from "react";
import "./ArrangementPreviewButton.scss";
import {useArrangementPreviewButtonLogic} from "./ArrangementPreviewButton.logic";
import {FontIcon} from "../../../../common/FontIcon";
import {LessonPreviewType} from "../../../../../client/models/songs/LessonPreviewType";

interface IArrangementPreviewButton {
  label: string;
  ariaLabel: string;
  audioUrl: string;
  lessonId: number;
  previewType: LessonPreviewType;
}

export const ArrangementPreviewButton: VoidFunctionComponent<IArrangementPreviewButton> = ({label, ariaLabel, audioUrl, lessonId, previewType}) => {
  const {audioRef, isPreviewPlaying, toggleAudio, resetAudioPreview} = useArrangementPreviewButtonLogic(lessonId, previewType);

  return (
    <>
      <audio className={`previewAudio`} src={audioUrl} ref={audioRef} onEnded={resetAudioPreview} />
      <button className={`arrangementPreviewButton`} aria-label={ariaLabel} title={ariaLabel} onClick={toggleAudio}>
        <FontIcon icon={isPreviewPlaying ? "icon-pause" : "icon-play"} />
        <span className={`buttonLabel`}>{label}</span>
      </button>
    </>
  );
}